import { render, staticRenderFns } from "./CustomNav.vue?vue&type=template&id=3f24eaec&scoped=true&"
import script from "./CustomNav.vue?vue&type=script&lang=js&"
export * from "./CustomNav.vue?vue&type=script&lang=js&"
import style0 from "./CustomNav.vue?vue&type=style&index=0&id=3f24eaec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f24eaec",
  null
  
)

export default component.exports